import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { InviteSheet } from '~/features/team/invite-sheet';

const search = z.object({ inviteId: z.string().optional() });

function InviteRoute(): ReactElement {
  const { inviteId } = Route.useSearch();
  return <InviteSheet inviteId={inviteId} />;
}

/**
 * Invite a person: the right sheet over the Team table, in three steps
 * (web-redesign-03 phase 5). `?inviteId=` opens one that already exists.
 */
export const Route = createFileRoute('/_app/business/_team/invite')({
  validateSearch: search,
  component: InviteRoute,
});
